export default __webpack_public_path__ + "278ed084386581b12cde3b3c4079e677.jpg";